import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar';
import { DocContentImage, DocModalImage, DocSidebarImage } from '../component/DocMedia';
import SettingsMenuOverview from './SettingsMenuOverview';
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function Roles() {
    const { t } = useTranslation();
    const image001 = useDocImage('roles-img', 'image001.png', 'settings');
    const image002 = useDocImage('roles-img', 'image002.png', 'settings');
    const image003 = useDocImage('roles-img', 'image003.png', 'settings');
    const image004 = useDocImage('roles-img', 'image004.png', 'settings');
    const image005 = useDocImage('roles-img', 'image005.png', 'settings');
    const image006 = useDocImage('roles-img', 'image006.png', 'settings');
    const image007 = useDocImage('roles-img', 'image007.png', 'settings');

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>

                            <h1 className='mt-0 text-primary'>{t('documentation.roles.title')}</h1>
                            <p className='header-para'>
                                {t('documentation.roles.introLine1')} <br />
                                {t('documentation.roles.introLine2')}
                            </p>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.roles.accessing.title')}
                                </div>
                                <div className="card-body">
                                    <p>{t('documentation.roles.accessing.intro')}</p>
                                    <SettingsMenuOverview />
                                    <ul>
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.roles.accessing.steps.step1') }} />
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.roles.accessing.steps.step2') }} />
                                    </ul>
                                    <DocSidebarImage src={image001} alt={t('documentation.roles.accessing.imageAlt')} />
                                    <ul className="mb-0">
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.roles.accessing.steps.step3') }} />
                                    </ul>
                                    <p><b>{t('documentation.roles.search.title')}</b></p>
                                    <DocContentImage src={image002} alt={t('documentation.roles.search.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.roles.search.steps.step1')}</li>
                                        <li>{t('documentation.roles.search.steps.step2')}</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.roles.listOverview.title')}
                                </div>
                                <div className="card-body">
                                    <p>{t('documentation.roles.listOverview.intro')}</p>
                                    <DocContentImage src={image003} alt={t('documentation.roles.listOverview.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.roles.listOverview.columns.srNo')}</li>
                                        <li>{t('documentation.roles.listOverview.columns.names')}</li>
                                        <li>{t('documentation.roles.listOverview.columns.dateAdded')}</li>
                                        <li>{t('documentation.roles.listOverview.columns.actions')}</li>
                                    </ul>

                                    <p><b>{t('documentation.roles.editing.title')}</b></p>
                                    <DocModalImage src={image004} alt={t('documentation.roles.editing.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.roles.editing.steps.step1')}</li>
                                        <li>{t('documentation.roles.editing.steps.step2')}</li>
                                        <li>{t('documentation.roles.editing.steps.step3')}</li>
                                    </ul>

                                    <p><b>{t('documentation.roles.deleting.title')}</b></p>
                                    <DocModalImage src={image005} alt={t('documentation.roles.deleting.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.roles.deleting.steps.step1')}</li>
                                        <li>{t('documentation.roles.deleting.steps.step2')}</li>
                                        <li>{t('documentation.roles.deleting.steps.step3')}</li>
                                    </ul>

                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.roles.addRole.title')}
                                </div>
                                <div className="card-body">

                                    <ul>
                                       
                                        <li>{t('documentation.roles.addRole.steps.step1')}</li>
                                        <li>{t('documentation.roles.addRole.steps.step2')}</li>
                                    </ul>
                                    <DocModalImage src={image006} alt={t('documentation.roles.addRole.formImageAlt')} />
                                    <ul>
                                        <li>{t('documentation.roles.addRole.fields.roleName')}</li>
                                        <li>{t('documentation.roles.addRole.fields.parentRole')}</li>
                                        <li>{t('documentation.roles.addRole.fields.permissionsTitle')}</li>
                                    </ul>
                                    <DocModalImage src={image007} alt={t('documentation.roles.addRole.permissionsImageAlt')} className="doc-media--wide" />
                                    <ul>
                                        <li>{t('documentation.roles.addRole.fields.view')}</li>
                                        <li>{t('documentation.roles.addRole.fields.add')}</li>
                                        <li>{t('documentation.roles.addRole.fields.edit')}</li>
                                        <li>{t('documentation.roles.addRole.fields.delete')}</li>
                                        <li>{t('documentation.roles.addRole.fields.checkbox')}</li>
                                        <li>{t('documentation.roles.addRole.fields.parentRolesNote')}</li>
                                        <li>{t('documentation.roles.addRole.fields.permissionsNote')}</li>
                                        <li>
                                            {t('documentation.roles.addRole.saveAction')}
                                            <ul className="pt-10">
                                                <li>{t('documentation.roles.addRole.saveOptions.cancel')}</li>
                                                <li>{t('documentation.roles.addRole.saveOptions.save')}</li>
                                            </ul>
                                        </li>
                                    </ul>



                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
